/* eslint-disable react/no-children-prop */
import React, { useState } from 'react';
import ModalWrapper from 'Common/Components/ModalWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { selectVulnsSelected, selectSelectedMainVulns } from 'store/Manage/selectors';
import { markDuplicates } from 'store/Manage/duplicateActions';
import isNull from 'lodash/isNull';
import { unSelectAll } from 'store/Manage/actions';
import { PropTypes } from 'prop-types';
import { ModalContent, RadioButtonsContainer } from './styled';
import RadioItem from './components/RadioItem';
import Buttons from './components/Buttons';
import Texts from './components/Texts';
import useKeyPress from 'Hooks/useKeyPress';

const MarkAsDuplicateModal = ({ hideModal }) => {
  const [mainID, setMainID] = useState(null);
  const dispatch = useDispatch();
  const selectedVulns = useSelector(selectVulnsSelected);
  const selectedVulnsIDs = selectedVulns.map((v) => v.id);
  const selectionMains = useSelector(selectSelectedMainVulns);

  const markAsDuplicates = () => {
    dispatch(markDuplicates(selectedVulnsIDs, mainID));
    dispatch(unSelectAll());
    setMainID(null);
    hideModal();
  };
  const onRadioClick = ({ target }) => setMainID(Number(target.value));

  const cancel = () => {
    setMainID(null);
    hideModal();
  };

  useKeyPress(() => {
    cancel();
  }, ['Escape']);

  useKeyPress(() => {
    markAsDuplicates();
  }, ['Enter']);

  return (
    <ModalWrapper>
      <ModalContent>
        <Texts />
        <RadioButtonsContainer>
          { selectionMains.map((m) => <RadioItem key={ m.id } vuln={ m } onRadioClick={ onRadioClick } checked={ m.id === mainID } />) }
        </RadioButtonsContainer>
        <Buttons onCancelClick={ cancel } onConfirmClick={ markAsDuplicates } disabled={ isNull(mainID) } />
      </ModalContent>
    </ModalWrapper>
  );
};

MarkAsDuplicateModal.propTypes = {
  hideModal: PropTypes.func.isRequired
};

export default MarkAsDuplicateModal;
